"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Flyout.css");
var Utils = require("player-core/utils");
var Flyout = (function (_super) {
    __extends(Flyout, _super);
    function Flyout(props) {
        var _this = _super.call(this, props) || this;
        _this._onClose = _this._onClose.bind(_this);
        _this._escHandler = _this._escHandler.bind(_this);
        _this._setFlyoutClose = _this._setFlyoutClose.bind(_this);
        _this._setFlyoutOpen = _this._setFlyoutOpen.bind(_this);
        _this._flyoutID = _this.props.id || "flyout_" + Utils.createUUID();
        return _this;
    }
    Flyout.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            this._setFlyoutOpen();
        }
    };
    Flyout.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this._setFlyoutOpen();
        }
        else if (!this.props.isOpen && prevProps.isOpen) {
            this._setFlyoutClose();
        }
    };
    Flyout.prototype.componentWillUnmount = function () {
        this._setFlyoutClose();
    };
    Flyout.prototype._setFlyoutOpen = function () {
        this.refFlyout.focus();
        window.addEventListener('keydown', this._escHandler);
        Utils.addNoScroll();
    };
    Flyout.prototype._setFlyoutClose = function () {
        window.removeEventListener('keydown', this._escHandler);
        Utils.removeNoScroll();
    };
    Flyout.prototype._onClose = function () {
        this.props.onClose && this.props.onClose(this.props.id);
    };
    Flyout.prototype._escHandler = function (e) {
        if (e.keyCode === 27) {
            this._onClose();
        }
    };
    Flyout.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpen = _a.isOpen, size = _a.size, altSide = _a.altSide, children = _a.children, tag = _a.tag;
        var cssClasses = ['p-flyout', size.toLowerCase()];
        if (isOpen) {
            cssClasses.push('isOpen');
        }
        if (altSide) {
            cssClasses.push('altSide');
        }
        var props = {
            ref: function (r) { _this.refFlyout = r; },
            "className": cssClasses.join(' '),
            "tabIndex": (isOpen) ? 0 : -1,
            "data-tag": tag,
            "aria-hidden": !isOpen
        };
        return (React.createElement("div", __assign({}, props),
            React.createElement("div", { className: 'background', onClick: this._onClose }),
            React.createElement("div", { className: 'inner', id: this._flyoutID }, children)));
    };
    ;
    return Flyout;
}(React.Component));
Flyout.defaultProps = {
    id: '',
    isOpen: true,
    size: 'Large',
    altSide: false,
    children: [],
    tag: null,
    onClose: void (0)
};
exports.Flyout = Flyout;
;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['layout-controls'])
        csod.engine.controls['layout-controls'] = {};
    csod.engine.controls['layout-controls']['Flyout'] = Flyout;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Flyout"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-layout-controls/controls/Flyout/index.js
// module id = 753
// module chunks = 0